import * as React from 'react';

import ThinBannerModule from 'bundles/unified-description-page-common/components/modules/thin-banner/ThinBannerModule';
import EnterpriseThinBannerCta from 'bundles/unified-description-page-common/components/shared/EnterpriseThinBannerCta';
import { useIsEnterpriseLearner } from 'bundles/unified-description-page-common/contexts/UserContext';

import _t from 'i18n!nls/xdp';

const ThinBannerModuleRenderer = () => {
  const { isEnterpriseLearner, loadingIsEnterpriseLearner } = useIsEnterpriseLearner();

  if (loadingIsEnterpriseLearner || isEnterpriseLearner) {
    return null;
  }

  return (
    <ThinBannerModule
      cta={<EnterpriseThinBannerCta />}
      title={_t('See how employees at top companies are mastering in-demand skills')}
    />
  );
};

export default ThinBannerModuleRenderer;
